export function setJsonLdWithId(scriptId: string, data: Record<string, any>) {
  const id = `jsonld-${scriptId}`;
  let el = document.getElementById(id) as HTMLScriptElement | null;
  if (!el) {
    el = document.createElement('script');
    el.id = id;
    el.type = 'application/ld+json';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

// Backward-compatible default (single script)
export function setJsonLd(data: Record<string, any>) {
  setJsonLdWithId('dynamic', data);
}

